module.exports = __webpack_public_path__ + "img/slide3.291c856c.png";